export const MUTATION_DELETE_AUTH_PARTNER = /* GraphQL */ `
	mutation ($id: String!) {
		deleteAuthPartner(id: $id)
	}
`;
